import { CustomNode } from '../../../types';
import { attributeSplitIcon } from '../../../icons';

const DEFAULT_ICON = attributeSplitIcon;

export const attributeSplitConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: DEFAULT_ICON,
    };
  },
};
